module.exports = __webpack_public_path__ + "media/images/products/retailers-socialmedia-3-tweets-multi-links-0999da99d0f5d8c6a305eb4e80e30843.jpg";